/**
 * The sign-in link carries its token in the URL fragment, which survives mail scanners
 * but not client-side navigation: the 401 on the initial profile fetch redirects to
 * /sign-in and drops it long before the sign-in page mounts. So the token is read once,
 * at module load, before React renders anything.
 */
const readMagicTokenFromUrl = (): string | null => {
  const hash = window.location.hash.slice(1);

  if (!hash) return null;

  const token = new URLSearchParams(hash).get('magicToken');

  if (!token) return null;

  // Drop it from the address bar immediately so it never lingers in history or a referrer.
  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${window.location.search}`,
  );

  return token;
};

const pendingMagicToken = readMagicTokenFromUrl();

export const getPendingMagicToken = (): string | null => pendingMagicToken;
